import {
  CONNECT_QUESTIONS_EMERGENCY,
  GOAL_OPTIONS,
} from "@components/OnboardingWizard/quizStepsConfig";

/** 大类卡入口归因（埋点 `entry`，fe-spec §3.6） */
export type ConnectCardEntry = "suggest_chip" | "composer_menu" | "ed_suggest";

/** US2 连接项发出的隐藏协议行：空 label → SilentEntry，不出用户气泡 */
export const CONNECT_ACCOUNT_SILENT_MESSAGE =
  "[](referenceType=portfolio_link)\n";

const isSilentPortfolioLink = (content: string): boolean =>
  content.trim() === CONNECT_ACCOUNT_SILENT_MESSAGE.trim();

/** 问题池全部文案（英文原句 + 当前 locale 译文），用于识别「这是槽位题发出的消息」 */
const connectQuestionTexts = (): Set<string> => {
  const groups = [
    ...GOAL_OPTIONS.map((option) => option.connectQuestions),
    CONNECT_QUESTIONS_EMERGENCY,
  ];
  const texts = new Set<string>();
  for (const group of groups) {
    for (const question of group?.questions ?? []) {
      texts.add(question.prompt);
      texts.add(question.label());
    }
  }
  return texts;
};

/**
 * 按卡片**前一条**用户消息推导入口：
 * 隐藏 portfolio_link → composer_menu；命中问题池 → suggest_chip；其余 → ed_suggest。
 */
export function resolveCardEntry(
  previousUserContent: string | undefined,
): ConnectCardEntry {
  const content = previousUserContent ?? "";
  if (isSilentPortfolioLink(content)) {
    return "composer_menu";
  }
  if (connectQuestionTexts().has(content.trim())) {
    return "suggest_chip";
  }
  return "ed_suggest";
}
